

























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { institutionServer, processServe } from '@/api/installServer';
import PagingUnit from '@/components/paging/paging.vue';
import EditDialog from '@/views/professionalWork/workflow/flowWorkCustom/unit/editDialog.vue';

import TransferDrawer from '@/views/professionalWork/workflow/flowWorkCustom/unit/transferDrawer.vue';
import DealDrawer from '@/views/professionalWork/workflow/flowWorkCustom/unit/dealWithDrawer.vue';
import UserModule from '@/store/modules/user';
@Component({
  components: { PagingUnit, EditDialog, TransferDrawer, DealDrawer },
})
export default class FlowWorkCustom extends Vue {
  editMark = false;
  flowData: any;
  code = '';
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total: any = 0;
  formList: any = [];

  flowDataHandle: any = {};

  deptTree: any;

  mounted() {
    this.getAllData();
    this.getList();
  }

  back() {
    this.getAllData();
    this.getList();
    this.editMark = false;
  }

  getList(val?: any) {
    institutionServer
      .getAllDeptStaff({
        name: val ? val : null,
      })
      .then((res: any) => {
        this.deptTree = res.data.deptList;
        UserModule.setDeptTree(this.deptTree);
      })
      .catch((error: any) => {
        // this.$message.error('获取数据失败');
      });
  }

  getListData() {
    this.getAllData();
  }

  showEdit() {
    processServe
      .getFlowExampleInfo(this.code)
      .then((res: any) => {
        // console.log(res.data);
        this.flowData = res.data;
        this.editMark = true;
      })
      .catch((e: any) => {});
  }

  handleFlow(item: any) {
    processServe
      .getOperateContent(item.id)
      .then((res: any) => {
        if ((res.data.operateWay === 'approve' || res.data.operateWay === 'handle') && res.data.isOperate === true) {
          this.flowDataHandle = res.data;
          this.flowDataHandle.id = item.id;
          // this.getFlowLog(item);
          this.dealDrawer(item, this.flowDataHandle);
        }
        if (res.data.isOperate === false) {
          this.flowDataHandle = res.data;
          this.flowDataHandle.id = item.id;
          // this.getFlowLog(item);
          this.transferDrawer(item, this.flowDataHandle);
        }
      })
      .catch((e: any) => {});
  }

  getFlowLog(item: any) {
    processServe
      .getFlowExampleLog(item.id)
      .then((res: any) => {
        console.log(res.data);
      })
      .catch((e: any) => {});
  }

  transferDrawer(form: any, flowDataHandle: any) {
    const ref: any = this.$refs.transfer;
    ref.showDrawer(form, flowDataHandle);
  }

  dealDrawer(form: any, flowDataHandle: any) {
    console.log(flowDataHandle);
    const ref: any = this.$refs.dealWith;
    ref.showDrawer(form, flowDataHandle);
  }

  getAllData() {
    this.editMark = false;
    const arr: any = this.$route.path.split('/');
    this.code = arr[arr.length - 1];
    this.getDataByCode();
    // this.getInfoByCode();
  }

  getInfoByCode(code: any) {
    processServe
      .getFlowExampleInfo(code)
      .then((res: any) => {
        console.log(res.data);
      })
      .catch((e: any) => {});
  }

  getDataByCode() {
    const obj = {
      code: this.code,
      ...this.queryDataForm,
    };
    processServe
      .getFlowExample(obj)
      .then((res: any) => {
        console.log(res.data);
        this.formList = res.data.records;
        this.total = res.data.total;
      })
      .catch((e: any) => {});
  }

  @Watch('$route', {})
  routeChange() {
    this.getAllData();
  }
}
